export type ScLegalBannerProps = {
  variant?: "footer" | "inline" | "app";
  className?: string;
};

const LEGAL_TERMS_URL = "https://auth.speedycore.com.au/legal/terms";
const LEGAL_PRIVACY_URL = "https://auth.speedycore.com.au/legal/privacy";

export function IdentityFooter() {
  return (
    <footer
      className="sc-identity-footer sc-legal-footer"
      style={{
        padding: "1.25rem 1rem",
        background: "#f8fafc",
        borderTop: "1px solid #e2e8f0",
        textAlign: "center",
        color: "#334155",
        fontSize: "0.82rem",
        lineHeight: 1.5,
      }}
    >
      <p
        className="sc-legal-footer-text"
        style={{ margin: "0 0 0.4rem 0" }}
      >
        This app is provided by <strong>Speedy Systems Pty Ltd</strong> and
        governed by the Speedy Systems{" "}
        <a
          href={LEGAL_TERMS_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1e3a8a",
            textDecoration: "underline",
            fontWeight: 500,
          }}
        >
          Terms &amp; Conditions
        </a>
        {" "}and{" "}
        <a
          href={LEGAL_PRIVACY_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#1e3a8a",
            textDecoration: "underline",
            fontWeight: 500,
          }}
        >
          Privacy Policy
        </a>
        .
      </p>
      <p
        className="sc-legal-footer-sub"
        style={{ margin: 0, color: "#64748b", fontSize: "0.75rem" }}
      >
        Powered by SpeedyCore Identity · One account · One acceptance · Full
        coverage
      </p>
    </footer>
  );
}

export function IdentityFooterInline() {
  return (
    <p
      className="sc-legal-footer-inline"
      style={{
        margin: "0.6rem 0 0 0",
        padding: "0.55rem 0.75rem",
        background: "#f8fafc",
        border: "1px solid #e2e8f0",
        borderRadius: "8px",
        color: "#334155",
        fontSize: "0.75rem",
        lineHeight: 1.5,
        textAlign: "center",
      }}
    >
      Provided by <strong>Speedy Systems Pty Ltd</strong> ·{" "}
      <a
        href={LEGAL_TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#1e3a8a", textDecoration: "underline" }}
      >
        T&amp;C
      </a>
      {" · "}
      <a
        href={LEGAL_PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#1e3a8a", textDecoration: "underline" }}
      >
        Privacy
      </a>
    </p>
  );
}

export function ScLegalAppBanner(props: ScLegalBannerProps) {
  const { className } = props;
  const h = (0, eval)("React.createElement");

  const termsLink = h(
    "a",
    {
      href: LEGAL_TERMS_URL,
      target: "_blank",
      rel: "noopener noreferrer",
      style: {
        color: "#1e3a8a",
        textDecoration: "underline",
        fontWeight: 500,
      },
    },
    "Terms & Conditions",
  );

  const privacyLink = h(
    "a",
    {
      href: LEGAL_PRIVACY_URL,
      target: "_blank",
      rel: "noopener noreferrer",
      style: {
        color: "#1e3a8a",
        textDecoration: "underline",
        fontWeight: 500,
      },
    },
    "Privacy Policy",
  );

  const strong = h(
    "strong",
    null,
    "Speedy Systems Pty Ltd",
  );

  const mainText = h(
    "p",
    {
      className: "sc-legal-footer-text",
      style: { margin: "0 0 0.4rem 0" },
    },
    "This app is provided by ",
    strong,
    " and governed by the Speedy Systems ",
    termsLink,
    " and ",
    privacyLink,
    ".",
  );

  const subText = h(
    "p",
    {
      className: "sc-legal-footer-sub",
      style: { margin: 0, color: "#64748b", fontSize: "0.75rem" },
    },
    "Powered by SpeedyCore Identity · One account · One acceptance · Full coverage",
  );

  return h(
    "footer",
    {
      className: `sc-identity-footer sc-legal-footer sc-legal-app-banner${className ? ` ${className}` : ""}`,
      style: {
        padding: "1.25rem 1rem",
        background: "#ffffff",
        borderTop: "1px solid #e2e8f0",
        textAlign: "center",
        color: "#334155",
        fontSize: "0.82rem",
        lineHeight: 1.5,
      },
    },
    mainText,
    subText,
  );
}
